export const routesDef = {
  HomePage: {
    name: 'Home',
    path: '/',
  },
  PayrollPage: {
    name: 'Payroll',
    path: '/payroll',
  },

  PayrollPrivacyPolicyPage: {
    name: 'Payroll',
    path: '/payroll/privacy-policy/latest',
  },

  PayrollTermsAndConditionPage: {
    name: 'Payroll',
    path: '/payroll/terms-and-condition/latest',
  },

  HaulerPage: {
    name: 'Hauler',
    path: '/hauler',
  },

  HaulerPrivacyPolicyPage: {
    name: 'Hauler',
    path: '/hauler/privacy-policy/latest',
  },

  HaulerTermsAndConditionPage: {
    name: 'Hauler',
    path: '/hauler/terms-and-condition/latest',
  },

  HaulerNextPage: {
    name: 'Hauler Next',
    path: '/hauler-next',
  },

  LabPage: {
    name: 'Lab',
    path: '/lab',
  },

  LabPrivacyPolicyPage: {
    name: 'Lab',
    path: '/lab/privacy-policy/latest',
  },
  LabTermsAndConditionPage: {
    name: 'Lab',
    path: '/lab/terms-and-condition/latest',
  },

  PrincipalPage: {
    name: 'Principal',
    path: '/principal',
  },

  PrincipalPrivacyPolicyPage: {
    name: 'Principal',
    path: '/principal/privacy-policy/latest',
  },
  PrincipalTermsAndConditionPage: {
    name: 'Principal',
    path: '/principal/terms-and-condition/latest',
  },

  DocsPage: {
    name: 'Documents',
    path: '/docs',
  },

  DocItemPage: {
    name: 'Document Item',
    path: '/docs/posts/:slug',
  },

  DataDeletionRequest: {
    name: 'Document Item',
    path: '/data-deletion-request',
  },
}
